import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { ComiteService } from "src/app/services/comite.service";

@Component({
  selector: "app-comite-detalle",
  templateUrl: "./comite-detalle.component.html",
  styleUrls: ["./comite-detalle.component.css"],
})
export class ComiteDetalleComponent implements OnInit {
  public details: any;
  private id: string = "";
  private subscription: Subscription = new Subscription();

  constructor(
    private service: ComiteService,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id") || "";
    if (this.id) {
      this.loadComiteDetail(this.id);
    } else {
      this.close();
    }
  }

  async getCatalog() {
    const get = await this.service.getCatalogo();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public close() {
    this.location.back();
  }

  get emailList(): string[] {
    return this.details?.correo
      ? this.details.correo
          .split(",")
          .map((email) => email.trim())
          .filter((email) => email !== "")
      : [];
  }

  private async loadComiteDetail(id: string): Promise<void> {
    try {
      const details = await this.service.getComitesDetail(id);
      this.details = details.results;
      this.details.fechaIntegracion = this.updateDate(
        this.details.fechaIntegracion
      );
    } catch (error) {
      console.log("error");
    }
  }

  public updateDate(date: any): string | null {
    const fechaIntegracion = date;

    if (fechaIntegracion) {
      const fecha = new Date(fechaIntegracion);
        const dia = fecha.getUTCDate().toString().padStart(2, "0");
      const mes = (fecha.getUTCMonth() + 1).toString().padStart(2, "0");
      const anio = fecha.getUTCFullYear(); 
        const fechaFormateada = `${dia}/${mes}/${anio}`;
      return fechaFormateada;
    }
    return null;
  }
}
